// TA-11104: exact FlashList cell heights for the Invite-from-Phone contact
// list (ContactList with `isFromChatInviteFriends`), including the 16px
// MarginTopM separator FlashList renders inside each cell: contact row
// 48 + 16, letter header 40 + 16. Exact sizes put every row and every A-Z
// jump target in the right place on the first paint. That matters here
// because the list runs with FlashList's native layout pass off (see
// FlashListPlainViewCell), so a row sized from an estimate is painted at the
// estimated spot first and moved a moment later.
export const INVITE_ROW_CELL_HEIGHT = 64;
export const INVITE_HEADER_CELL_HEIGHT = 56;

/**
 * Fixed cell height for an item in the Invite-from-Phone list, or `undefined`
 * to let FlashList size the cell from its estimate and then measure it.
 * Returns `undefined` when the user scales fonts, because rows then grow past
 * the fixed heights.
 */
export const getInviteItemLayoutSize = (
  item: unknown,
  fontScale: number
): number | undefined => {
  if (fontScale !== 1) return undefined;
  return typeof item === 'string'
    ? INVITE_HEADER_CELL_HEIGHT
    : INVITE_ROW_CELL_HEIGHT;
};
